/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';

import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type GetMetricEventsByProjectPathParams = NonNullable<
  operations['getMetricEventsByProject']['parameters']['path']
>;

export type GetMetricEventsByProjectQueryParams = NonNullable<
  operations['getMetricEventsByProject']['parameters']['query']
>;

export interface Input extends GetMetricEventsByProjectPathParams {
  apiVersion?: string;
  query?: GetMetricEventsByProjectQueryParams;
}

export async function getMetricEventsByProject(
  { apiVersion, query, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().GET('/internal/projects/{projectKey}/metric-events', {
    params: { path, query },
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
